import ApiServer from "../ApiServer.ts";
import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import * as libLocation from "../lib/location.ts";
import {getCurrentBudget,buildSummary} from "../server/objects/BudgetBeans.ts";
import { attachSwipeDetector } from "../lib/SwipeDetector.ts";

import TPL from "../widget/launchpadV3.mustache";
import { format } from "../lib/DateUtils.ts";

export {initDom,destroyDom}
Html.registerWidget('widget/launchpadV3',{initDom,destroyDom})

var currentIndex=0;

var urlBySection = {
    ACTIVITY:'wall.php',
    LIST:'tasks.php',
    MAP:'map.php',
    MESSAGE:'im.php',
    CONTACT:'contacts.php',
    GALLERY:'gallery.php',
    CALENDAR:'events.php',
    SPECIAL_DAYS:"specialdays.php",
    FAMILY:'settings.php?tab=settings_edit_members',
    MEALPLANNER:'mealplanner.php',
    RECIPEBOX:'recipebox.php',
    TIMETABLE:'timetable.php',
    SETTINGS:'settings.php',
    BUDGET:'budget.php',
    FILER:'document.php'
}
Html.registerDom({
  launchpadclick(section){
    //FIXME a click is needed server side
    if(section!=='MESSAGE'){
      ApiServer.launchpadclick(section);
    }
    if(section==="PREMIUM"){
      Html.trigger(null,"takepremium")
    }else{
      libLocation.goTo(urlBySection[section]);
    }
  },
  launchpadclickaction(action,metaId,url){
    var clickaction = {
      INVITE:"inviteOnClickAction",
      WALL_VIEW:"launchpadclick|ACTIVITY",
      WALL_POST:"launchpadclick|ACTIVITY",
      PHOTO_CREATE:"launchpadclick|ACTIVITY",
      EVENT_VIEW:"evtclick|"+metaId,
      BIRTHDAY_VIEW:"evtclick|"+metaId,
      EVENT_CREATE:"eventcreate",
      CALENDAR:"launchpadclick|CALENDAR",
      CALENDAR_SETTINGS:"launchpadclick|CALENDAR",
      PROFILE_EDIT:"modaluseredit",
      FAMILY_CREATE:"modalcreatecircleonClickAction",
      FAMILY:"launchpadclick|FAMILY",
      URL:"openurl|"+url,
      MESSAGE:"launchpadclick|MESSAGE",
      LOCATION:"launchpadclick|LOCATION",
      CHECKIN_CREATE:"launchpadclick|LOCATION",
      PLACE_CREATE:"launchpadclick|LOCATION",
      LIST:"launchpadclick|LIST",
      LIST_CREATE:"launchpadclick|LIST",
      CONTACT:"launchpadclick|CONTACT",
      CONTACT_CREATE:"launchpadclick|CONTACT_CREATE",
      GALLERY:"launchpadclick|GALLERY",
      MEALPLANNER:"launchpadclick|MEALPLANNER",
      RECIPEBOX:"launchpadclick|RECIPEBOX",
      RECIPE_CREATE:"launchpadclick|RECIPEBOX",
      TIMETABLE:"launchpadclick|TIMETABLE",
      TIMETABLE_CREATE:"launchpadclick|TIMETABLE",
      SETTINGS:"launchpadclick|SETTINGS",
      MESSAGE_CREATE:"launchpadclick|MESSAGE",
      BUDGET:"launchpadclick|BUDGET",
      SPECIAL_DAYS:"launchpadclick|SPECIAL_DAYS",

      PREMIUM:"takepremium",
      PREMIUM_RECURRINGTASKS:"takepremium",
      PREMIUM_RECIPE:"takepremium",
      PREMIUM_MEALPLANNER:"takepremium",
      PREMIUM_CALENDARSYNC:"takepremium",
      PREMIUM_TIMETABLE:"takepremium",
      PREMIUM_LOCATION:"takepremium"



    }[action];
    if(clickaction){
      Html.triggerbystring(this,clickaction)
    }else{
      console.log('error no clickaction for '+action)
    }


  }
});

Object.assign(ApiServer.types.LaunchpadBean.prototype,{
  onDecode(){
    this.eventDisplayDay = !!this.eventDayCount;
    this.eventDisplayWeek = !this.eventDayCount && this.eventWeekCount;
    this.eventDisplayMonth = !this.eventWeekCount && this.eventMonthCount;

    this.eventDisplayNone = !this.eventMonthCount && !this.eventWeekCount && !this.eventDayCount;

    if(this.timetableUpcomingEventDate){
      this.timetableUpcomingEventDisplayDate = format(this.timetableUpcomingEventDate,'dddd LT')
    }
  }
});
Object.assign(ApiServer.types.LaunchpadActivityBean.prototype,{
  onDecode(){
    this['is'+this.action] = true;

    if(this.items && this.items.length>3) {
      this.items.splice(2,this.items.length-2,
        new ApiServer.types.LaunchpadActivityItemBean({color:"#cccccc",title:i18n.get('launchpad.otherevents',(this.items.length-2))})
      );
    }

  }
});

var theBean;
function display(container: HTMLElement){
  if(theBean.activity){
    var nextIdx = theBean.activities.indexOf(theBean.activity)+1;
    if(nextIdx<theBean.activities.length){
      theBean.activity = theBean.activities[nextIdx]
    }
  }else{
    theBean.activity = theBean.activities[0]
  }
  Html.setHtml(container,TPL,theBean);
  showIndex()

  // Event delegation for nav clicks
  container.addEventListener('click',  Html.createDelegateListener('.launchpad-nav>span',function(evt, matchingTarget){
    var crawler = matchingTarget as Element;
    currentIndex = 0;
    while((crawler = crawler.previousElementSibling)!=null){
      currentIndex++;
    }
    showIndex(true)
  }));

  // Swipe functionality
  const activitiesEl = container.querySelector<HTMLElement>(".launchpad-activities");
  if(activitiesEl){
    attachSwipeDetector(activitiesEl, {
      swipeRight(){
        currentIndex--;
        setTimeout(function(){showIndex(true);},50)
      },
      swipeLeft(){
        currentIndex++;
        setTimeout(function(){showIndex(true);},50)
      }
    });
  }
}
function showIndex(smooth?:boolean){
  if(currentIndex<0) currentIndex=0;
  const activities = document.querySelectorAll<HTMLElement>(".launchpad-activities>span");

  if(currentIndex>=activities.length) currentIndex=activities.length-1;
  const currentActivity = theBean.activities[currentIndex];

  document.querySelectorAll<HTMLElement>(".launchpad-nav>span").forEach((span,idx)=>{
    span.classList.toggle('selected',idx===currentIndex);
  });

  if(currentActivity && currentActivity.screenSeenKeyEnum){
    ApiServer.launchpadseen(currentActivity.screenSeenKeyEnum,()=>{},()=>{})
  }
  activities[currentIndex]?.scrollIntoView({behavior :smooth?"smooth":"auto"})
}


function clean(){
  theBean = null;
  currentIndex=0;

}
amplify.subscribe('familyScopeChange sessionExpired',clean)

var currentContainer: HTMLElement;

function initDom(container: HTMLElement){
  currentContainer = container;
  loadAndDisplay()
  amplify.subscribe('modified',loadAndDisplay)
}
function destroyDom(container: HTMLElement){
  currentContainer = null;
  amplify.unsubscribe('modified',loadAndDisplay)
}

function loadAndDisplay(){
  amplify.publish("budgetNeedRefresh")
  ApiServer.launchpadget3(theBean?theBean.token:null,null,null,function(launchpadBean){
    theBean = launchpadBean;

    var budget = getCurrentBudget();
    if(budget){

      theBean.budgetSummary = buildSummary(budget,budget.getTransactionList())
    }
    display(currentContainer);
  });
}